import { isNil } from 'lodash'
import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import map from '..'
import { expandLeftToolbar, collapseLeftToolbar } from '../../../action/left-toolbar-state-actions'
import { createContent, buildContent } from '../infoWindow'
import { infoWindowOpenAction, infoWindowCloseAction } from '../../../action/infowindow-action'
import { selectedObjectId, selectedObjectIdNull } from '../../../action/map-object-id'
import sharedCluster, { createInvisibleMarker, rebuildCluster } from '../sharedMarkerCluster'
import { normalizeTrackWidth } from '../../../lib/trackColor'
import { contentVisibilityKey } from '../../../action/hidden-content-ids-actions'
import { visibleActiveVendors } from '../../../lib/layerVisibility'

const RenderCircles = (props) => {
  const [disableObj, setDisabelObj] = useState(props.disableMapObj.disableMapObject)
  const [infowindowsState, setInfowindowsState] = useState(null)
  const [previousState, setPreviousState] = useState(null)
  let { infoWindowOpenAction, infoWindow } = props
  let openInfoWindow = null;
  const circleRefs = useRef({});
  const circleClusterMarkersRef = useRef([]);
  const circleMarkerMapRef = useRef({});

  // Cleanup when circles are deleted from Redux state
  useEffect(() => {
    if (!props.mapReference) return;
    const currentIds = new Set(props.circles.map(c => c.id));
    const removedIds = Object.keys(circleRefs.current).filter(id => !currentIds.has(Number(id)));
    if (removedIds.length === 0) return;
    removedIds.forEach(id => {
      circleRefs.current[id].setMap(null);
      delete circleRefs.current[id];
      const invisibleMarker = circleMarkerMapRef.current[id];
      if (invisibleMarker) {
        invisibleMarker.map = null;
        sharedCluster.circleMarkers = sharedCluster.circleMarkers.filter(m => m !== invisibleMarker);
        delete circleMarkerMapRef.current[id];
      }
    });
    rebuildCluster(props.mapReference);
  }, [props.circles]);

  // My Content per-type show/hide for shapes (circles are part of "shapes"). Remove
  // each user circle's shape + cluster proxy and clear mapObj when hidden so the
  // render-body diff re-draws it when shown. Vendor circles are unaffected.
  useEffect(() => {
    if (!props.mapReference) return;
    if (!props.hiddenContentTypes.includes('shapes')) return;
    let changed = false;
    props.circles.forEach(circle => {
      const id = circle.id;
      if (circleRefs.current[id]) {
        try { circleRefs.current[id].setMap(null) } catch (e) { /* already gone */ }
        delete circleRefs.current[id];
      }
      const invisibleMarker = circleMarkerMapRef.current[id];
      if (invisibleMarker) {
        invisibleMarker.map = null;
        sharedCluster.circleMarkers = sharedCluster.circleMarkers.filter(m => m !== invisibleMarker);
        circleClusterMarkersRef.current = circleClusterMarkersRef.current.filter(m => m !== invisibleMarker);
        delete circleMarkerMapRef.current[id];
        changed = true;
      }
      const mapObject = typeof circle.mapObj === 'function' ? circle.mapObj() : circle.mapObj;
      if (mapObject && typeof mapObject.setMap === 'function') {
        try { mapObject.setMap(null) } catch (e) { /* already gone */ }
        circle.mapObj = null;
        changed = true;
      }
    });
    if (changed) rebuildCluster(props.mapReference);
  }, [props.hiddenContentTypes, props.mapReference, props.circles]);

  // My Content per-OBJECT hide (WEB-7047). Same teardown as the per-type effect
  // above, but for individually-hidden circles. Clearing mapObj lets the
  // render-body below re-draw the circle when it is shown again.
  useEffect(() => {
    if (!props.mapReference) return;
    let changed = false;
    props.circles.forEach(circle => {
      if (!props.hiddenContentIds.includes(contentVisibilityKey('circle', circle.id))) return;
      const id = circle.id;
      if (circleRefs.current[id]) {
        try { circleRefs.current[id].setMap(null) } catch (e) { /* already gone */ }
        delete circleRefs.current[id];
      }
      const invisibleMarker = circleMarkerMapRef.current[id];
      if (invisibleMarker) {
        invisibleMarker.map = null;
        sharedCluster.circleMarkers = sharedCluster.circleMarkers.filter(m => m !== invisibleMarker);
        circleClusterMarkersRef.current = circleClusterMarkersRef.current.filter(m => m !== invisibleMarker);
        delete circleMarkerMapRef.current[id];
        changed = true;
      }
      const mapObject = typeof circle.mapObj === 'function' ? circle.mapObj() : circle.mapObj;
      if (mapObject && typeof mapObject.setMap === 'function') {
        try { mapObject.setMap(null) } catch (e) { /* already gone */ }
        circle.mapObj = null;
        changed = true;
      }
    });
    if (changed) rebuildCluster(props.mapReference);
  }, [props.hiddenContentIds, props.mapReference, props.circles]);

  useEffect(() => {
    props.circles.forEach(circle => {
      const mapObject = typeof circle.mapObj === 'function' ? circle.mapObj() : circle.mapObj;
      if (mapObject && typeof mapObject.setOptions === 'function') {
        mapObject.setOptions({ clickable: props.disableMapObj.disableMapObject });
      }
    });
    setDisabelObj(props.disableMapObj.disableMapObject)
  }, [props.disableMapObj.disableMapObject, props.circles]);

  useEffect(() => {
    if (previousState) {
      previousState.close()
    }
    setPreviousState(infowindowsState)
  }, [infowindowsState])

  let storeInfoBox = (value) => {
    setInfowindowsState(value);
    infoWindowOpenAction(value)
  }

  const { expandLeftToolbar, circles, collapseLeftToolbar, mapReference, activeVendors, vendors, disableMapObj, selectedObjectId, selectedObjectIdNull, hiddenContentTypes, hiddenContentIds } = props,
    hideShapes = hiddenContentTypes.includes('shapes'),
    vendorCircles = activeVendors.map(id => {
      return vendors[id] && vendors[id]['objects'] && vendors[id]['objects']['circles'] ?
        vendors[id]['objects']['circles'].filter(circle => isNil(circle.mapObj) && !isNil(circle.geoJson)) : []
    }),
    toAdd = (hideShapes ? [] : circles.filter(circle => isNil(circle.mapObj) && !hiddenContentIds.includes(contentVisibilityKey('circle', circle.id)))).concat(vendorCircles.flat())
  if (!isNil(mapReference) && toAdd.length > 0) {
    const shapeData = [];
    toAdd.forEach(circle => {
      if (circle == 'Max object count check failed - user has too many objects')
        return

      circle['measureType'] = 'circle'
      if (!circle.geoJson) {
        return
      }

      if (!circleRefs.current[circle.id]) {  // Only add marker if not already on the map
      } else {
        circleRefs.current[circle.id].setMap(null)
        delete circleRefs.current[circle.id];
      }

      const geoJson = JSON.parse(circle.geoJson),
        coords = new google.maps.LatLng(geoJson.features[0].geometry.coordinates[1], geoJson.features[0].geometry.coordinates[0]),
        mapCircle = new google.maps.Circle({
          name: circle.name,
          map: null,
          // map: mapReference,
          center: coords,
          strokeColor: geoJson.features[0].properties?.line?.color || '#fff'
            ? geoJson.features[0].properties?.line?.color.length == 9
              ? '#' + geoJson.features[0].properties?.line?.color.substring(3, 9)
              : geoJson.features[0].properties?.line?.color
            : '#0009F9',
          fillColor: geoJson.features[0].properties?.line?.color
            ? geoJson.features[0].properties?.line?.color.length == 9
              ? '#' + geoJson.features[0].properties?.line?.color.substring(3, 9)
              : geoJson.features[0].properties?.line?.color
            : '#0009F9',
          strokeOpacity: 1,
          strokeWeight: normalizeTrackWidth(geoJson.features[0].properties?.line?.width),
          zIndex: 10,
          radius: geoJson.features[0].properties.radius,
          options: {
            draggable: false,
            clickable: true,
            cursor: 'pointer'
          }
        })
      circle['mapObj'] = function () { return mapCircle }
      mapCircle.setOptions({ clickable: disableObj });
      mapCircle.addListener('click', (event) => {
        selectedObjectId(circle.id)
        const latLng = event.latLng;
        const lat = latLng.lat();
        const lng = latLng.lng();
        let infoPosition = { lat: lat, lng: lng }
        let editFunction = (infoWindow) => {
          closeFunction(infoWindow)
          // infoWindowOpenAction(null)
          collapseLeftToolbar()
          expandLeftToolbar({ dialog: 'edit', editable: circle })
          selectedObjectIdNull()
        }
        const closeFunction = (infoWindow) => {
          openInfoWindow = infoWindow;
          openInfoWindow.close();
          // infoWindowOpenAction(null)
          setInfowindowsState(null)
          selectedObjectIdNull()
        }
        const updateInfoWindow = (value) => {
          openInfoWindow = value
        }
        const dispatchFunction = (value) => {
          storeInfoBox(value)
        }
        createContent({ shapeDetails: circle, mapObj: mapCircle, infoWindow, type: 'circle', infoPosition }, { editFunction, closeFunction, updateInfoWindow }, dispatchFunction);
      })
      circleRefs.current[circle.id] = mapCircle;
      shapeData.push({
        id: circle.id,
        pos: { lat: geoJson.features[0].geometry.coordinates[1], lng: geoJson.features[0].geometry.coordinates[0] },
        shape: mapCircle,
      });
    });

    circleClusterMarkersRef.current.forEach(m => { m.map = null; });
    Promise.all(shapeData.map(({ pos }) => createInvisibleMarker(pos))).then(markers => {
      const validMarkers = [];
      markers.forEach((m, i) => {
        if (!m) return; // shape had invalid geoJson coordinates; skip it (WEB-7033)
        m._shape = shapeData[i].shape;
        circleMarkerMapRef.current[shapeData[i].id] = m;
        validMarkers.push(m);
      });
      circleClusterMarkersRef.current = validMarkers;
      sharedCluster.circleMarkers = validMarkers;
      rebuildCluster(mapReference);
    });
  }
  return null
}

const mapStateToProps = state => ({
  // Hidden by the global layers eye toggle along with the layers they came from (WEB-7048).
  activeVendors: visibleActiveVendors(state),
  vendors: state.vendors,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  circles: state.circles,
  disableMapObj: state.disableMapObj,
  infoWindow: state.infoWindow,
  hiddenContentTypes: state.hiddenContentTypes,
  hiddenContentIds: state.hiddenContentIds
})

const mapDispatchToProps = dispatch => ({
  expandLeftToolbar: props => dispatch(expandLeftToolbar(props)),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  infoWindowOpenAction: (payload) => dispatch(infoWindowOpenAction(payload)),
  selectedObjectId: (payload) => dispatch(selectedObjectId(payload)),
  selectedObjectIdNull: () => dispatch(selectedObjectIdNull())
})

export default connect(mapStateToProps, mapDispatchToProps)(RenderCircles)